<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 14.0858V2.5H13V14.0858L16.2929 10.7929L17.7071 12.2071L12.7071 17.2071L12 17.9142L11.2929 17.2071L6.29289 12.2071L7.70711 10.7929L11 14.0858ZM3 21.5V19.5H21V21.5H3Z"
    />
  </svg>
</template>
